// extracted by mini-css-extract-plugin
export default {"demoButton":"demoButton--nmwxP","ny":"ny--gTxjc"};